import React, { useEffect, createElement } from 'react';
import { Home } from './pages/Home';
const META_PIXEL_ID = '2496693134127557';
const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700&family=Oswald:wght@400;500;600;700&display=swap';
// Load Google Fonts WITHOUT blocking render: preconnect + stylesheet swapped from
// media="print" to media="all" on load. display=swap shows fallback text instantly.
function useAsyncFonts() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.getElementById('gf-async')) return;
    const pre1 = document.createElement('link');
    pre1.rel = 'preconnect';
    pre1.href = 'https://fonts.googleapis.com';
    document.head.appendChild(pre1);
    const pre2 = document.createElement('link');
    pre2.rel = 'preconnect';
    pre2.href = 'https://fonts.gstatic.com';
    pre2.crossOrigin = 'anonymous';
    document.head.appendChild(pre2);
    const link = document.createElement('link');
    link.id = 'gf-async';
    link.rel = 'stylesheet';
    link.href = FONTS_HREF;
    link.media = 'print';
    link.onload = () => {
      link.media = 'all';
    };
    document.head.appendChild(link);
  }, []);
}
// UTMify pixel — sets window.pixelId and loads the tracking script async/defer.
function useUtmifyPixel(pixelId: string) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.getElementById('utmify-pixel')) return;
    (window as any).pixelId = pixelId;
    const a = document.createElement('script');
    a.id = 'utmify-pixel';
    a.setAttribute('async', '');
    a.setAttribute('defer', '');
    a.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
    document.head.appendChild(a);
    // UTMify UTM tracking script
    if (!document.getElementById('utmify-utms')) {
      const u = document.createElement('script');
      u.id = 'utmify-utms';
      u.setAttribute('src', 'https://cdn.utmify.com.br/scripts/utms/latest.js');
      u.setAttribute('data-utmify-prevent-xcod-sck', '');
      u.setAttribute('data-utmify-prevent-subids', '');
      u.setAttribute('async', '');
      u.setAttribute('defer', '');
      document.head.appendChild(u);
    }
  }, [pixelId]);
}
function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double init
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
      return;
    }
    /* eslint-disable */
    ;
    (function (f: any, b: Document, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement('script') as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
  }, [pixelId]);
}
export function App() {
  useAsyncFonts();
  useUtmifyPixel('6a34d7fed71acf8727ccdc1a');
  useMetaPixel(META_PIXEL_ID);
  return <>
      <Home data-id="element-0" />
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>
    </>;
}